import {
  Breadcrumb as AriaBreadcrumb,
  Breadcrumbs as AriaBreadcrumbs,
  type BreadcrumbProps,
  type BreadcrumbsProps as AriaBreadcrumbsProps,
} from 'react-aria-components';
import { twMerge } from 'tailwind-merge';
import { Link } from './link';
import { getDomainValue } from 'utils/domain';
import { LabChevronLeftIcon } from 'components/camperlab/icons/chevron-left';

function Separator() {
  return getDomainValue({
    camperlab: (
      <svg width="2" height="2" viewBox="0 0 2 2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="2" height="2" fill="currentColor" />
      </svg>
    ),
    camper: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
        <path fill="currentColor" d="m9.313 7.646.354-.353.707.707-.354.354-.707-.708Zm.707.708-3.333 3.333-.707-.707 3.333-3.334.707.708Z" />
        <path fill="currentColor" d="m9.313 8.354.354.353.707-.707-.354-.354-.707.708ZM5.98 5.02l3.333 3.334.707-.708-3.333-3.333-.707.707Z" />
      </svg>
    ),
    nnormal: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
        <path fill="currentColor" d="m9.313 7.646.354-.353.707.707-.354.354-.707-.708Zm.707.708-3.333 3.333-.707-.707 3.333-3.334.707.708Z" />
        <path fill="currentColor" d="m9.313 8.354.354.353.707-.707-.354-.354-.707.708ZM5.98 5.02l3.333 3.334.707-.708-3.333-3.333-.707.707Z" />
      </svg>
    ),
  });
}

export type BreadcrumbItem = {
  name: string;
  id: string;
  href?: string;
};

type BreadcrumbsProps = Omit<AriaBreadcrumbsProps<BreadcrumbItem>, 'children'>;

export function Breadcrumbs(props: BreadcrumbsProps) {
  return (
    <AriaBreadcrumbs {...props} className={twMerge('mb-0 flex flex-wrap gap-1', props.className)}>
      {(item) => (
        <AriaBreadcrumb className={twMerge('flex items-center gap-1 text-disabled', props.className)}>
          <Link
            variant="none"
            href={item.href}
            className="inline-flex text-sm text-disabled current:text-copy hover:text-copy focus:text-copy lab:font-bold lab:uppercase md:text-xs"
          >
            {item.name}
          </Link>
          {item.href && (
            <div className="flex items-center justify-center lab:size-3.5">
              <Separator />
            </div>
          )}
        </AriaBreadcrumb>
      )}
    </AriaBreadcrumbs>
  );
}

export function MobileBreadcrumbs({ last, current }: { current: BreadcrumbItem; last: BreadcrumbItem }) {
  return (
    <div className="inline-flex items-baseline gap-2.5">
      <Link variant="none" href={last?.href} className="inline-flex self-center text-sm text-copy lab:font-bold lab:uppercase md:text-xs">
        <LabChevronLeftIcon />
        <span className="sr-only">{last.name}</span>
      </Link>
      <p className="mb-0 inline-flex text-sm text-copy lab:font-bold lab:uppercase md:text-xs">{current?.name}</p>
    </div>
  );
}
